import { Component, inject, ChangeDetectionStrategy } from "@angular/core";
import { FormControl, FormGroup, ReactiveFormsModule, Validators } from "@angular/forms";
import { TranslateModule } from "@ngx-translate/core";
import { DynamicDialogConfig, DynamicDialogRef } from "@openng/optimus-ui/dynamicdialog";
import { InputTextModule } from "@openng/optimus-ui/inputtext";
import { ButtonComponent } from "../../../../../shared/components/button/button.component";
import {
  ControllerManufacturer,
  ControllerManufacturerObject,
} from "../../../../../models/api/fault/controllerManufacturer";
import { TextareaModule } from "@openng/optimus-ui/textarea";

@Component({
  standalone: true,
  selector: "app-controller-manufacturer",
  imports: [ButtonComponent, ReactiveFormsModule, TranslateModule, InputTextModule, TextareaModule],
  templateUrl: "./manufacturer.component.html",
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: "./manufacturer.component.scss",
})
export class ManufacturerComponent {
  private config = inject(DynamicDialogConfig);
  private ref = inject(DynamicDialogRef);

  private manufacturer: ControllerManufacturer = new ControllerManufacturer(this.config.data.controllerCatalogItem);
  public form = new FormGroup({
    label: new FormControl(this.manufacturer.label, Validators.required),
    notes: new FormControl(this.manufacturer.notes),
  });

  /**
   * Saves the manufacturer.
   * If the form is valid and the 'label' field has a value, constructs a ManufacturerObject and assigns it to the properties of the controller manufacturer.
   * Closes the dialog with the controller manufacturer as the result.
   */
  save() {
    const manufacturerValues = this.form?.value;
    if (this.form.valid && manufacturerValues && manufacturerValues.label) {
      const manufacturer: ControllerManufacturerObject = {
        label: manufacturerValues.label,
        notes: manufacturerValues.notes,
      };
      this.manufacturer.properties = manufacturer;
      this.ref.close(this.manufacturer);
    }
  }

  /**
   * Closes the dialog without returning any value.
   */
  closeDialog() {
    this.ref.close();
  }
}
